<section id="top" class="xl:w-full">
  <div class="relative mx-auto max-w-screen-2xl">
    <img
      src="assets/img/Futureoftelco/Top-ilustration.svg"
      class="absolute hidden top-image md:block"
    />
    <div id="intro" class="w-10/12 mx-auto sm:w-9/12 py-14 lg:py-28">
      <h1
        class="text-4xl font-bold leading-loose bg-white sm:text-5xl sm:max-w-xl whitespace-pre-line"
      >
        {{ "fot.intro.title" | translate | breakOn: ":" : "after" }}
      </h1>
      <div class="md:hidden">
        <p class="pt-10 purple">{{ "fot.intro.subtitle" | translate }}</p>
        <a langRouterLink
          ><img
            src="assets/img/Futureoftelco/logo.svg"
            alt="pygmalios"
            class="w-32 pt-1 pl-px sm:w-44"
        /></a>
      </div>
      <p class="pt-10 purple md:w-2/5 xl:max-w-xs xl:w-full">
        {{ "fot.intro.text" | translate }}
      </p>
      <div class="relative">
        <img
          src="assets/img/Futureoftelco/Top-ilustration.svg"
          class="relative w-4/5 mx-auto -mb-24 top-mobile mt-7 md:hidden"
        />
      </div>
      <div class="hidden md:block">
        <p class="purple md:pt-40">{{ "fot.intro.subtitle" | translate }}</p>
        <a langRouterLink
          ><img
            src="assets/img/Futureoftelco/logo.svg"
            alt="pygmalios"
            class="w-32 pt-1 pl-px sm:w-44"
        /></a>
      </div>
    </div>
  </div>
</section>

<div class="mx-auto max-w-screen-2xl">
  <div id="key-takeaways" class="justify-center mt-20 md:mt-14 lg:mt-28">
    <div class="w-5/6 mx-auto sm:w-4/5 xl:w-3/5">
      <h4 class="mb-10 text-xl font-bold sm:text-2xl">
        {{ "fot.takeaways.title" | translate }}
      </h4>
      <div class="swiper">
        <div class="swiper-wrapper">
          @for (takeaway of takeaways; track takeaway) {
            <div class="swiper-slide cards">
              <header class="py-8 pl-8 pr-6 text-xl">
                {{ `fot.takeaways.card${takeaway}.title` | translate }}
              </header>
              <p class="pb-8 pl-8 pr-6 text-left">
                {{ `fot.takeaways.card${takeaway}.body` | translate }}
              </p>
            </div>
          }
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <div class="max-w-6xl mx-auto">
      <section
        id="retail-shopping"
        class="justify-center w-5/6 max-w-5xl mx-auto inner-container sm:w-4/5 xl:w-3/5"
      >
        <h3 class="pb-6 text-4xl font-bold pt-14 sm:pt-24 sm:text-5xl">
          {{ "fot.retail_shopping.title" | translate }}
        </h3>
        <hr class="w-24 border-solid" />

        @for (test of testimonials; track test.id) {
          <p class="py-10 sm:py-14">
            {{ `fot.retail_shopping.test${test.id}.text` | translate }}
          </p>
          <div class="relative flex flex-wrap cards sm:flex-nowrap">
            <img
              class="w-40 h-40 mt-8 ml-8 rounded-full sm:my-8"
              [src]="`assets/img/Futureoftelco/${test.image}.jpg`"
              alt="Figure"
            />
            <article class="px-8 py-8 align-middle rounded-lg purple-content">
              ‘{{ `fot.retail_shopping.test${test.id}.body` | translate }}’
              <span class="block pt-3">
                {{ `fot.retail_shopping.test${test.id}.footer` | translate }}
              </span>
            </article>
          </div>
        }

        <p class="max-w-xl py-10 mx-auto text-3xl sm:py-14">
          {{ "fot.retail_shopping.message" | translate }}
        </p>
      </section>

      <div class="py-10 cards sm:py-14">
        <section
          id="graph"
          class="w-5/6 max-w-5xl mx-auto mt-0 inner-container sm:w-4/5 xl:w-3/5"
        >
          <div class="flex items-end justify-between sm:items-start">
            <header class="max-w-xs mr-10 text-lg font-bold sm:text-xl">
              {{ "fot.graph.title" | translate }}
            </header>
            <img
              src="assets/img/Futureoftelco/legend.svg"
              alt="Fig"
              class="w-1/6"
            />
          </div>
          <img
            src="assets/img/Futureoftelco/Graf.png"
            alt="Fig"
            class="w-full pt-4 sm:pt-14"
          />
          <p class="pt-8 text-xs describe-graph sm:text-sm">
            {{ "fot.graph.description" | translate }}
          </p>
        </section>
      </div>

      <section
        class="w-5/6 max-w-5xl mx-auto mt-0 inner-container sm:w-4/5 xl:w-3/5"
      >
        <p class="py-10 sm:py-14">
          {{ "fot.o2.adv" | translate }}
        </p>
        <a href="assets/PDF/2-CS-O2.pdf" target="_blank">
          <img
            class="hidden w-full mx-auto sm:block"
            src="assets/img/Futureoftelco/O2-image.jpg"
            alt="advertisement"
          />
          <img
            class="w-full max-w-xs mx-auto sm:hidden"
            src="assets/img/Futureoftelco/O2-image-m.jpg"
            alt="advertisement"
          />
        </a>
      </section>

      <section
        id="it-is-time"
        class="w-5/6 max-w-5xl mx-auto mt-0 inner-container sm:w-4/5 xl:w-3/5"
      >
        <h3 class="pb-6 text-4xl font-bold pt-14 sm:text-5xl sm:pt-24">
          {{ "fot.time.title" | translate }}
        </h3>
        <hr class="w-24 border-solid" />
        <p class="pt-9">
          <a
            class="underline link"
            href="https://www.accenture.com/_acnmedia/pdf-60/accenture-end-of-the-local-telecom-store-pov_final.pdf"
            target="_blank"
          >
            Accenture</a
          >
          {{ "fot.time.intro1" | translate }}
          <strong>{{ "fot.time.intro2" | translate }}</strong>
          {{ "fot.time.intro3" | translate }}
          <strong>60%</strong>
          {{ "fot.time.intro4" | translate }}
        </p>
        <ul class="pt-9">
          <li class="pl-2 ml-5 sm:ml-0 sm:pl-0">
            {{ "fot.time.item1.part1" | translate }}
            <a
              class="underline link"
              href="https://www.accenture.com/_acnmedia/pdf-60/accenture-end-of-the-local-telecom-store-pov_final.pdf"
              target="_blank"
            >
              {{ "fot.time.item1.part2" | translate }}
            </a>
            {{ "fot.time.item1.part3" | translate }}
          </li>
          <li class="pt-6 pl-2 ml-5 sm:ml-0 sm:pl-0">
            <a
              class="underline link"
              href="https://www.accenture.com/_acnmedia/pdf-60/accenture-end-of-the-local-telecom-store-pov_final.pdf"
              target="_blank"
            >
              {{ "fot.time.item2.part1" | translate }}
            </a>
            {{ "fot.time.item2.part2" | translate }}
          </li>
        </ul>
        <p class="max-w-xl mx-auto text-3xl py-14">
          {{ "fot.time.message" | translate }}
        </p>
      </section>

      <section
        id="omnichannel-approach"
        class="justify-center w-5/6 max-w-5xl mx-auto inner-container sm:w-4/5 xl:w-3/5"
      >
        <h4 class="pb-6 text-2xl font-bold">
          {{ "fot.omnichannel.title" | translate }}
        </h4>
        <p class="pb-10 sm:pb-14">
          {{ "fot.omnichannel.text1" | translate }}
        </p>

        <div class="relative flex flex-wrap cards sm:flex-nowrap">
          <img
            class="w-40 h-40 mt-8 ml-8 rounded-full sm:my-8"
            src="assets/img/Futureoftelco/liza_amlani.jpg"
            alt="Figure"
          />
          <article class="px-8 py-8 align-middle rounded-lg purple-content">
            ‘{{ "fot.omnichannel.card1.body" | translate }}’
            <span class="block pt-3">{{
              "fot.omnichannel.card1.footer" | translate
            }}</span>
          </article>
        </div>

        <div class="relative flex flex-wrap mt-5 cards sm:flex-nowrap">
          <img
            class="w-40 h-40 mt-8 ml-8 rounded-full sm:my-8"
            src="assets/img/Futureoftelco/jan_nekovar.jpg"
            alt="Figure"
          />
          <article class="px-8 py-8 align-middle rounded-lg purple-content">
            ‘{{ "fot.omnichannel.card2.body" | translate }}’
            <span class="block pt-3">{{
              "fot.omnichannel.card2.footer" | translate
            }}</span>
          </article>
        </div>

        <p class="py-10 sm:py-14">
          {{ "fot.omnichannel.text2" | translate }}
          <br /><br />
          {{ "fot.omnichannel.text3" | translate }}
        </p>

        <div class="relative flex flex-wrap cards sm:flex-nowrap">
          <img
            class="w-40 h-40 mt-8 ml-8 rounded-full sm:my-8"
            src="assets/img/Futureoftelco/liza_amlani.jpg"
            alt="Fig"
          />
          <article class="px-8 py-8 align-middle rounded-lg purple-content">
            ‘{{ "fot.omnichannel.card3.body" | translate }}’
            <span class="block pt-3 pb-6">{{
              "fot.omnichannel.card3.footer" | translate
            }}</span>
          </article>
        </div>

        <p class="py-10 sm:py-14">
          {{ "fot.omnichannel.text4" | translate }}
          <br /><br />
          {{ "fot.omnichannel.text5" | translate }}
        </p>
      </section>

      <section id="sample-telecom" class="w-full mx-auto cards">
        <div
          class="flex flex-wrap w-5/6 max-w-5xl py-10 mx-auto sm:py-14 inner-container sm:w-4/5 xl:w-3/5"
        >
          <header
            class="w-full pr-5 text-4xl sm:-ml-4 xl:-ml-0 sm:text-5xl md:pr-4 sm:w-1/2 md:w-1/3"
          >
            {{ "fot.sample.title" | translate }}
          </header>

          <div
            class="pr-4 mt-10 sm:pr-0 sm:pl-8 sm:mt-0 md:px-2 sm:w-1/2 md:w-1/3"
          >
            <img
              class="icon"
              src="assets/img/Futureoftelco/Classic.svg"
              alt="icon"
            />
            <h6 class="py-4 text-lg font-bold sm:text-2xl">
              {{ "fot.sample.classic.title" | translate }}
            </h6>
            <p>{{ "fot.sample.classic.body" | translate }}</p>
          </div>

          <div
            class="mt-10 sm:-ml-4 md:-ml-0 sm:pr-4 md:mt-0 md:pl-6 sm:w-1/2 md:w-1/3"
          >
            <img
              class="icon"
              src="assets/img/Futureoftelco/Convenient.svg"
              alt="icon"
            />
            <h6 class="py-4 text-lg font-bold sm:text-2xl">
              {{ "fot.sample.convenient.title" | translate }}
            </h6>
            <p>{{ "fot.sample.convenient.body" | translate }}</p>
          </div>

          <div
            class="hidden w-1/2 mt-12 md:pr-4 sm:-ml-4 xl:-ml-0 md:w-1/3 md:block"
          ></div>

          <div class="pr-4 mt-10 sm:pl-8 md:px-2 sm:w-1/2 md:mt-12 md:w-1/3">
            <img
              class="icon"
              src="assets/img/Futureoftelco/Express-pickup.svg"
              alt="icon"
            />
            <h6 class="py-4 text-lg font-bold sm:text-2xl">
              {{ "fot.sample.pickup.title" | translate }}
            </h6>
            <p>{{ "fot.sample.pickup.body" | translate }}</p>
          </div>

          <div
            class="mt-10 sm:-ml-4 md:-ml-0 sm:pr-4 md:pl-6 sm:w-1/2 sm:mt-12 md:w-1/3"
          >
            <img
              class="icon"
              src="assets/img/Futureoftelco/Experiental-showroom.svg"
              alt="icon"
            />
            <h6 class="py-4 text-lg font-bold sm:text-2xl">
              {{ "fot.sample.showroom.title" | translate }}
            </h6>
            <p>{{ "fot.sample.showroom.body" | translate }}</p>
          </div>

          <div
            class="pr-4 mt-12 sm:pl-8 sm:-ml-4 xl:-ml-0 md:pl-0 md:pr-4 sm:w-1/2 md:w-1/3"
          >
            <img
              class="icon"
              src="assets/img/Futureoftelco/Pop-up.svg"
              alt="icon"
            />
            <h6 class="py-4 text-lg font-bold sm:text-2xl">
              {{ "fot.sample.popup.title" | translate }}
            </h6>
            <p>{{ "fot.sample.popup.body" | translate }}</p>
          </div>

          <div
            class="mt-12 sm:-ml-4 md:-ml-0 sm:pr-4 md:px-2 sm:w-1/2 md:w-1/3"
          >
            <img
              class="icon"
              src="assets/img/Futureoftelco/Pop-in.svg"
              alt="icon"
            />
            <h6 class="py-4 text-lg font-bold sm:text-2xl">
              {{ "fot.sample.popin.title" | translate }}
            </h6>
            <p>{{ "fot.sample.popin.body" | translate }}</p>
          </div>

          <div class="pr-4 mt-12 sm:pl-8 md:pl-6 sm:w-1/2 md:w-1/3">
            <img
              class="icon"
              src="assets/img/Futureoftelco/Kiosk.svg"
              alt="icon"
            />
            <h6 class="py-4 text-lg font-bold sm:text-2xl">
              {{ "fot.sample.kiosk.title" | translate }}
            </h6>
            <p>{{ "fot.sample.kiosk.body" | translate }}</p>
          </div>
        </div>
      </section>

      <section
        class="w-5/6 max-w-5xl mx-auto mt-0 inner-container sm:w-4/5 xl:w-3/5"
      >
        <p class="py-10 sm:py-14">
          {{ "fot.sample.outro.text" | translate }}
          <a
            class="link"
            href="https://www.mckinsey.com/industries/retail/our-insights/retail-speaks-seven-imperatives-for-the-industry"
            target="_blank"
          >
            {{ "fot.sample.outro.link" | translate }}
          </a>
        </p>
      </section>
    </div>

    <app-subscribe [place]="'body of futureoftelco'"></app-subscribe>

    <div class="max-w-6xl mx-auto">
      <section
        id="personalization"
        class="w-5/6 max-w-5xl mx-auto mt-0 inner-container sm:w-4/5 xl:w-3/5"
      >
        <h4 class="pb-6 text-2xl font-bold pt-14">
          {{ "fot.personalization.title" | translate }}
        </h4>
        <p class="pb-10 sm:pb-14">
          {{ "fot.personalization.intro1" | translate }}
          <br /><br />
          {{ "fot.personalization.intro2" | translate }}
        </p>
      </section>

      <div class="cards">
        <section id="today" class="w-full pb-8 mx-auto">
          <div
            class="w-5/6 max-w-5xl pt-10 mx-auto mt-0 inner-container sm:pt-14 sm:w-4/5 xl:w-3/5"
          >
            <header
              class="mr-10 text-lg font-bold sm:-ml-4 xl:-ml-0 sm:text-xl sm:pb-2"
            >
              {{ "fot.personalization.today.title" | translate }}
            </header>
            <p class="pt-6 sm:-ml-4 xl:-ml-0">
              {{ "fot.personalization.today.intro" | translate }}
            </p>
            <hr class="mt-8 border sm:hidden" />
          </div>
        </section>

        <section
          id="today-content"
          class="w-5/6 max-w-5xl pb-10 mx-auto mt-0 inner-container sm:pb-14 sm:w-4/5 xl:w-3/5"
        >
          <div
            class="flex flex-wrap mx-auto sm:flex-nowrap sm:justify-center sm:max-w-2xl md:max-w-3xl lg:max-w-5xl whitespace-pre-line"
          >
            <div class="relative w-full">
              <p class="text-lg font-bold pre-visit sm:-ml-4 xl:-ml-0 sm:pb-10">
                {{
                  "fot.personalization.today.awareness.title"
                    | translate
                    | breakOn: "("
                }}
              </p>
              <div class="relative pb-4 pr-12 sm:-ml-4 xl:-ml-0 lg:pr-20">
                <img
                  class="w-6 py-4 sm:py-0 sm:absolute smile-left"
                  src="assets/img/Futureoftelco/smile-down.svg"
                  alt="happy"
                />
                <p>
                  {{ "fot.personalization.today.awareness.cons" | translate }}
                </p>
              </div>
              <img
                class="w-12 my-12 -ml-5 sm:absolute arrow lg:w-16"
                src="assets/img/Futureoftelco/arrow.svg"
                alt="arrow"
              />
            </div>

            <div class="relative w-full sm:pl-3 xl:pl-7">
              <p
                class="text-lg font-bold during-the-visit sm:-ml-4 xl:-ml-0 sm:pb-10"
              >
                {{
                  "fot.personalization.today.conversion.title"
                    | translate
                    | breakOn: "("
                }}
              </p>
              <div class="relative pb-4 pr-10 sm:-ml-4 xl:-ml-0 lg:pr-20">
                <img
                  class="w-5 py-4 sm:py-0 sm:absolute smile-left sm:w-6"
                  src="assets/img/Futureoftelco/smile-down.svg"
                  alt="happy"
                />
                <p>
                  {{ "fot.personalization.today.conversion.cons1" | translate }}
                </p>
              </div>
              <div class="relative pb-4 pr-10 sm:-ml-4 xl:-ml-0 lg:pr-20">
                <img
                  class="w-5 py-4 sm:py-0 sm:absolute smile-left sm:w-6"
                  src="assets/img/Futureoftelco/smile-down.svg"
                  alt="happy"
                />
                <p>
                  {{ "fot.personalization.today.conversion.cons2" | translate }}
                </p>
              </div>
              <img
                class="w-12 my-12 -ml-5 sm:absolute arrow-right lg:w-16"
                src="assets/img/Futureoftelco/arrow.svg"
                alt="arrow"
              />
            </div>

            <div class="w-full sm:pl-6 xl:pl-14">
              <p class="text-lg font-bold post-visit sm:pb-10">
                {{
                  "fot.personalization.today.targeting.title"
                    | translate
                    | breakOn: "("
                }}
              </p>
              <div class="relative pb-4 pr-10 lg:pr-20">
                <img
                  class="w-5 py-4 sm:py-0 sm:absolute smile-left sm:w-6"
                  src="assets/img/Futureoftelco/smile-down.svg"
                  alt="happy"
                />
                <p>
                  {{ "fot.personalization.today.targeting.cons1" | translate }}
                </p>
              </div>
              <div class="relative pr-10 sm:pb-4 lg:pr-20">
                <img
                  class="w-5 py-4 sm:py-0 sm:absolute smile-left sm:w-6"
                  src="assets/img/Futureoftelco/smile-down.svg"
                  alt="happy"
                />
                <p>
                  {{ "fot.personalization.today.targeting.cons2" | translate }}
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section
        class="w-5/6 max-w-5xl mx-auto mt-0 inner-container sm:w-4/5 xl:w-3/5"
      >
        <p class="py-10 sm:py-14">
          <a
            class="link"
            href="https://www.mckinsey.com/business-functions/operations/our-insights/a-transformation-in-store"
            target="_blank"
          >
            {{ "fot.personalization.midtext.link" | translate }}
          </a>
          {{ "fot.personalization.midtext.text1" | translate }}
          <a
            class="link"
            href="https://www.mckinsey.com/business-functions/marketing-and-sales/our-insights/the-end-of-shoppings-boundaries-omnichannel-personalization"
            target="_blank"
          >
            McKinsey
          </a>
          {{ "fot.personalization.midtext.text2" | translate }}
          <br /><br />
          {{ "fot.personalization.midtext.text3" | translate }}
          <br /><br />
          {{ "fot.personalization.midtext.text4" | translate }}
        </p>
      </section>

      <div class="cards">
        <section id="future" class="w-full mx-auto">
          <div
            class="w-5/6 max-w-5xl pt-10 mx-auto mt-0 inner-container sm:pt-14 sm:w-4/5 xl:w-3/5"
          >
            <header
              class="mr-10 text-lg font-bold sm:-ml-4 xl:-ml-0 sm:text-xl"
            >
              {{ "fot.personalization.future.title" | translate }}
            </header>
            <hr class="mt-8 border sm:hidden" />
          </div>
        </section>

        <section
          class="w-5/6 max-w-5xl pt-8 pb-10 mx-auto mt-0 inner-container sm:pb-14 sm:w-4/5 xl:w-3/5 whitespace-pre-line"
        >
          <div
            class="flex flex-wrap mx-auto sm:flex-nowrap sm:justify-center sm:max-w-2xl md:max-w-3xl lg:max-w-5xl"
          >
            <div class="relative w-full">
              <p class="text-lg font-bold pre-visit sm:-ml-4 xl:-ml-0">
                {{
                  "fot.personalization.future.awareness.title"
                    | translate
                    | breakOn: "("
                }}
              </p>
              <img
                class="w-56 my-8 sm:-ml-14 sm:h-28 lg:h-36"
                src="assets/img/Futureoftelco/pre-visit.svg"
                alt="pre-visit"
              />
              <div class="relative pb-4 pr-10 sm:-ml-4 xl:-ml-0 lg:pr-20">
                <img
                  class="w-6 pb-4 sm:absolute smile-left"
                  src="assets/img/Futureoftelco/smile-up.svg"
                  alt="happy"
                />
                <p>
                  {{ "fot.personalization.future.awareness.pros1" | translate }}
                </p>
              </div>
              <div class="relative pr-10 sm:-ml-4 xl:-ml-0 lg:pr-20">
                <img
                  class="w-5 sm:absolute smile-left sm:w-6"
                  src="assets/img/Futureoftelco/smile-up.svg"
                  alt="happy"
                />
                <p>
                  {{ "fot.personalization.future.awareness.pros2" | translate }}
                </p>
              </div>
              <img
                class="w-12 my-12 -ml-5 sm:absolute arrow lg:w-16"
                src="assets/img/Futureoftelco/arrow.svg"
                alt="arrow"
              />
            </div>

            <div class="relative w-full sm:pl-3 xl:pl-7">
              <p class="text-lg font-bold during-the-visit">
                {{
                  "fot.personalization.future.conversion.title"
                    | translate
                    | breakOn: "("
                }}
              </p>
              <img
                class="w-56 my-8 sm:-ml-8 sm:h-28 lg:h-36"
                src="assets/img/Futureoftelco/during-the-visit.svg"
                alt="during the visit"
              />
              <div class="relative pb-4 pr-10 lg:pr-14">
                <img
                  class="w-5 sm:absolute smile-left sm:w-6"
                  src="assets/img/Futureoftelco/smile-up.svg"
                  alt="happy"
                />
                <p>
                  {{
                    "fot.personalization.future.conversion.pros1" | translate
                  }}
                </p>
              </div>
              <div class="relative pb-4 pr-10 lg:pr-14">
                <img
                  class="w-5 sm:absolute smile-left sm:w-6"
                  src="assets/img/Futureoftelco/smile-up.svg"
                  alt="happy"
                />
                <p>
                  {{
                    "fot.personalization.future.conversion.pros2" | translate
                  }}
                </p>
              </div>
              <div class="relative pr-10 lg:pr-14">
                <img
                  class="w-5 sm:absolute smile-left sm:w-6"
                  src="assets/img/Futureoftelco/smile-up.svg"
                  alt="happy"
                />
                <p>
                  {{
                    "fot.personalization.future.conversion.pros3" | translate
                  }}
                </p>
              </div>
              <img
                class="w-12 my-12 -ml-5 sm:absolute arrow-right lg:w-16"
                src="assets/img/Futureoftelco/arrow.svg"
                alt="arrow"
              />
            </div>

            <div class="w-full sm:pl-6 xl:pl-14">
              <p class="text-lg font-bold post-visit">
                {{
                  "fot.personalization.future.targeting.title"
                    | translate
                    | breakOn: "("
                }}
              </p>
              <img
                class="w-56 my-8 sm:-ml-4 sm:h-28 lg:h-36"
                src="assets/img/Futureoftelco/post-visit.svg"
                alt="pre-visit"
              />
              <div class="relative pr-10 sm:pb-4 lg:pr-20">
                <img
                  class="w-5 sm:absolute smile-left sm:w-6"
                  src="assets/img/Futureoftelco/smile-up.svg"
                  alt="happy"
                />
                <p>
                  {{ "fot.personalization.future.targeting.pros" | translate }}
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section
        class="w-5/6 max-w-5xl mx-auto mt-0 inner-container sm:w-4/5 xl:w-3/5"
      >
        <p class="pt-10 sm:pt-14">
          {{ "fot.personalization.outro.text1" | translate }}
          <br /><br />
          <a
            class="link"
            href="https://f.hubspotusercontent20.net/hubfs/519470/04_Resources/02_Whitepapers/54_2021_Trends_In_Telecom_Report/2021-Trends%20in%20Telecom-Final_Report.pdf?__hstc=147153640.935e6ebb1b5de6a4b47b6b7376d60dea.1628513005664.1628513005664.1628513005664.1&__hssc=147153640.1.1628513005664&__hsfp=4185311437&hsCtaTracking=091780b7-ac90-4b6b-ae6f-68b8b57d595c%7C17f3cc58-cb64-4734-8836-846bef6807de"
            target="_blank"
          >
            {{ "fot.personalization.outro.link" | translate }}
          </a>
          {{ "fot.personalization.outro.text2" | translate }}
        </p>
      </section>

      <section
        id="digitalization"
        class="w-5/6 max-w-5xl mx-auto mt-0 inner-container sm:w-4/5 xl:w-3/5"
      >
        <h4 class="pt-10 pb-6 text-2xl font-bold sm:pt-14">
          {{ "fot.digitalization.title" | translate }}
        </h4>
        <p>
          {{ "fot.digitalization.text1" | translate }}
          <br /><br />
          {{ "fot.digitalization.text2" | translate }}
          <br /><br />
          {{ "fot.digitalization.text3" | translate }}
        </p>

        <a langRouterLink="virtual-queue">
          <img
            class="hidden w-full pt-10 mx-auto sm:pt-14 sm:block"
            src="assets/img/Futureoftelco/Pyg1-image.svg"
            alt="advertisement"
          />
          <img
            class="w-full max-w-xs pt-10 mx-auto sm:pt-14 sm:hidden"
            src="assets/img/Futureoftelco/Pyg1-image-m.svg"
            alt="advertisement"
          />
        </a>
        <p class="pt-10 sm:pt-14">
          {{ "fot.digitalization.text4" | translate }}
        </p>
        <a langRouterLink="getdemo">
          <img
            class="hidden w-full pt-10 mx-auto sm:pt-14 sm:block"
            src="assets/img/Futureoftelco/Pyg2-image.svg"
            alt="advertisement"
          />
          <img
            class="w-full max-w-xs pt-10 mx-auto sm:pt-14 sm:hidden"
            src="assets/img/Futureoftelco/Pyg2-image-m.svg"
            alt="advertisement"
          />
        </a>
      </section>

      <section
        id="bottom-page"
        class="w-5/6 max-w-5xl mx-auto mt-0 inner-container sm:w-4/5 xl:w-3/5"
      >
        <h3 class="pb-6 text-4xl font-bold pt-14 sm:pt-24 sm:text-5xl">
          {{ "fot.digitalization.future.title" | translate }}
        </h3>
        <hr class="w-24 border-solid" />
        <p class="py-10 sm:py-14">
          {{ "fot.digitalization.future.text1" | translate }}
          <br /><br />
          {{ "fot.digitalization.future.text2" | translate }}
        </p>
      </section>
    </div>

    <app-subscribe [place]="'footer of futureoftelco'"></app-subscribe>
    <div class="w-10/12 mx-auto xl:w-9/12">
      <app-share-buttons></app-share-buttons>
    </div>
  </div>
</div>
